type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * One selected item keeps its own name, so this returns undefined for a single
 * model object or a single sheet. Several sheets, or a mix, get a count that
 * names both kinds.
 */
export function selectionCountLabel(modelCount: number, sheetCount: number, t: Translate): string | undefined {
    if (sheetCount <= 0 || (modelCount <= 0 && sheetCount === 1)) {
        return undefined;
    }
    if (modelCount <= 0) {
        return t("selectionBarSheetsSelected", { count: sheetCount });
    }
    if (modelCount === 1 && sheetCount === 1) {
        return t("selectionBarObjectAndSheetSelected");
    }
    if (modelCount === 1) {
        return t("selectionBarObjectAndSheetsSelected", { sheetCount });
    }
    if (sheetCount === 1) {
        return t("selectionBarObjectsAndSheetSelected", { objectCount: modelCount });
    }
    return t("selectionBarObjectsAndSheetsSelected", { objectCount: modelCount, sheetCount });
}
